
















import Vue from 'vue';
import { mapState } from 'vuex';
import {
  Component, Prop,
} from 'vue-property-decorator';
import { Node, Edge } from '@/api/graph/';
import { StringMap } from '@/api/i18n/';
import { AnswerMap } from '@/api/AnswerMap';
import { marked } from 'marked';

@Component({ computed: mapState(['stringMap']) })
export default class AnswerSummary extends Vue {
    @Prop()
    node!: Node;

    @Prop()
    value!: string | string[] | null;

    @Prop()
    fiSettings!: AnswerMap;

    edges: Edge[] = [];

    hover: boolean = false;

    stringMap!: StringMap;

    getMarkdownStringAsHTML(stringId: string) {
      return marked(this.stringMap[stringId]);
    }

    mounted() {
      if (this.node && this.value) {
        if (this.node.type === Node.CHECKBOX_TYPE && Array.isArray(this.value)) {
          this.edges = this.node.getEdgesForAnswers(this.value as string[]);
        } else {
          const edge:Edge | null = this.node.getEdgeForAnswer(this.value);
          if (edge) {
            this.edges.push(edge);
          }
        }
      }
    }

    getAnswerHtml() : string {
      let html: string = '';
      for (let i = 0; i < this.edges.length; i++) {
        html += this.getMarkdownStringAsHTML(this.edges[i].getText(this.fiSettings));
      }
      return html;
    }
}
